const styles = () => ({
  '@global': {
    legend: {
      borderBottom: 'none',
    },
  },
})

export default styles
